import type { PlusToolName, SupportedRepubName } from './types';

/**
 * Plus home page paths for each republic
 */
export const PLUS_HOME_PAGE_PATHS = {
  WS: '/plus',
  US: '/us/plus',
  OC: '/plus',
  GZ: '/plus',
} satisfies Record<SupportedRepubName, string>;

/**
 * Plus tools restricted for each republic
 */
export const PLUS_TOOLS_RESTRICTED = {
  WS: [
    'event-overview',
    'match-centre',
    'player',
    'premium-market-movers',
    'premium-tipsters',
    'public-betting-data',
    'tipster',
  ],
} satisfies Partial<Record<SupportedRepubName, PlusToolName[]>>;
